export function convertToDollars(amount: number | undefined) {
  if (amount === undefined) {
    return '';
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);
}

export function convertCentsToDollars(
  amount: number,
  removeTrailingZeroes = false
) {
  const centsConversion = 100;
  const dollars = amount / centsConversion;

  if (removeTrailingZeroes) {
    return convertToDollars(dollars).replace(/(\.|,)00$/g, '');
  }
  return convertToDollars(dollars);
}
